import { BaseInstrumentation } from '@grafana/faro-web-sdk'

type ErrorReporter = (error: unknown, source: string) => void

export class FrontendErrorsInstrumentation extends BaseInstrumentation {
  readonly name = 'amitable-errors'
  readonly version = '1.0.0'

  constructor(private readonly report: ErrorReporter) {
    super()
  }

  private readonly onError = (event: ErrorEvent) => {
    this.report(event.error ?? new Error(event.message), 'window.error')
  }

  private readonly onRejection = (event: PromiseRejectionEvent) => {
    this.report(event.reason, 'unhandledrejection')
  }

  initialize() {
    window.addEventListener('error', this.onError)
    window.addEventListener('unhandledrejection', this.onRejection)
  }

  destroy() {
    window.removeEventListener('error', this.onError)
    window.removeEventListener('unhandledrejection', this.onRejection)
  }
}
